import axios, { type AxiosError } from 'axios';

import { omitCrossOriginCredentials } from './lib/crossOriginCredentials';
import {
  handleDeletionConstraintAxiosError,
  registerDeletionConstraintHttpErrorHandler,
  type ValidationErrorResponseBody
} from './lib/deletionConstraintErrorDispatch';
import {
  handleGlobalValidationAxiosError,
  registerGlobalValidationErrorHandler
} from './lib/globalValidationErrorDispatch';
import { registerVitePreloadErrorHandler } from './lib/handleVitePreloadError';
import {
  handleHttpRequestAxiosError,
  registerHttpRequestErrorHandler,
  registerHttpRequestErrorRouterHandler
} from './lib/httpRequestErrorDispatch';
import { configureMonacoLoader } from './lib/monacoLoader';
import { registerPagePreviewRequests } from './lib/pagePreviewRequest';
import { installSessionStorageFallback } from './lib/sessionStorageFallback';

installSessionStorageFallback();
registerVitePreloadErrorHandler();
registerDeletionConstraintHttpErrorHandler();
registerGlobalValidationErrorHandler();
registerHttpRequestErrorHandler();
registerHttpRequestErrorRouterHandler();
configureMonacoLoader();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] =
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
axios.defaults.withCredentials = true;
axios.interceptors.request.use(omitCrossOriginCredentials);

if (window.isPreviewing) {
  registerPagePreviewRequests();
}

axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ValidationErrorResponseBody>) => {
    handleDeletionConstraintAxiosError(error);
    handleGlobalValidationAxiosError(error);
    handleHttpRequestAxiosError(error);

    return Promise.reject(error);
  }
);

window.axios = axios;
